/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.4.0 (NJsonSchema v10.1.26.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class RegisterIdentityRequest implements IRegisterIdentityRequest {
    displayName!: string;
    email!: string;
    password!: string;
    termsAccepted!: boolean;

    constructor(data?: IRegisterIdentityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.termsAccepted = _data["termsAccepted"];
        }
    }

    static fromJS(data: any): RegisterIdentityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterIdentityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["termsAccepted"] = this.termsAccepted;
        return data; 
    }
}

export interface IRegisterIdentityRequest {
    displayName: string;
    email: string;
    password: string;
    termsAccepted: boolean;
}

export class LoginRequest implements ILoginRequest {
    email!: string;
    password!: string;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginRequest {
    email: string;
    password: string;
}

export class AuthResponse implements IAuthResponse {
    jwtToken!: string;
    refreshToken!: string;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jwtToken = _data["jwtToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwtToken"] = this.jwtToken;
        data["refreshToken"] = this.refreshToken;
        return data; 
    }
}

export interface IAuthResponse {
    jwtToken: string;
    refreshToken: string;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
    jwtToken!: string;
    refreshToken!: string;

    constructor(data?: IRefreshTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jwtToken = _data["jwtToken"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jwtToken"] = this.jwtToken;
        data["refreshToken"] = this.refreshToken;
        return data; 
    }
}

export interface IRefreshTokenRequest {
    jwtToken: string;
    refreshToken: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
    oldPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePasswordRequest {
    oldPassword: string;
    newPassword: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    email!: string;
    passwordResetToken!: string;
    newPassword!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.passwordResetToken = _data["passwordResetToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["passwordResetToken"] = this.passwordResetToken;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IResetPasswordRequest {
    email: string;
    passwordResetToken: string;
    newPassword: string;
}

export class RequestEmailChangeRequest implements IRequestEmailChangeRequest {
    newEmail!: string;

    constructor(data?: IRequestEmailChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): RequestEmailChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestEmailChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmail"] = this.newEmail;
        return data; 
    }
}

export interface IRequestEmailChangeRequest {
    newEmail: string;
}

export class RequestConfirmEmailRequest implements IRequestConfirmEmailRequest {
    email!: string;

    constructor(data?: IRequestConfirmEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestConfirmEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestConfirmEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IRequestConfirmEmailRequest {
    email: string;
}

export class FileUploadResponse implements IFileUploadResponse {
    fileUrl!: string;

    constructor(data?: IFileUploadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): FileUploadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        return data; 
    }
}

export interface IFileUploadResponse {
    fileUrl: string;
}

export enum ProjectStatus {
    Draft = "Draft",
    Pending = "Pending",
    Accepted = "Accepted",
    Rejected = "Rejected",
}

export class ProjectResponse implements IProjectResponse {
    id!: number;
    userId!: string;
    name!: string;
    payoff!: string;
    country!: string;
    description!: string;
    color!: string;
    coverImageUrl!: string;
    coverImageName!: string;
    logoUrl!: string;
    logoName!: string;
    status!: ProjectStatus;
    testUrl!: string;
    testOptions!: number;

    constructor(data?: IProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.payoff = _data["payoff"];
            this.country = _data["country"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.coverImageUrl = _data["coverImageUrl"];
            this.coverImageName = _data["coverImageName"];
            this.logoUrl = _data["logoUrl"];
            this.logoName = _data["logoName"];
            this.status = _data["status"];
            this.testUrl = _data["testUrl"];
            this.testOptions = _data["testOptions"];
        }
    }

    static fromJS(data: any): ProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["payoff"] = this.payoff;
        data["country"] = this.country;
        data["description"] = this.description;
        data["color"] = this.color;
        data["coverImageUrl"] = this.coverImageUrl;
        data["coverImageName"] = this.coverImageName;
        data["logoUrl"] = this.logoUrl;
        data["logoName"] = this.logoName;
        data["status"] = this.status;
        data["testUrl"] = this.testUrl;
        data["testOptions"] = this.testOptions;
        return data; 
    }
}

export interface IProjectResponse {
    id: number;
    userId: string;
    name: string;
    payoff: string;
    country: string;
    description: string;
    color: string;
    coverImageUrl: string;
    coverImageName: string;
    logoUrl: string;
    logoName: string;
    status: ProjectStatus;
    testUrl: string;
    testOptions: number;
}

export class ProjectRequest implements IProjectRequest {
    name!: string;
    payoff!: string;
    country!: string;
    description!: string;
    color!: string;
    coverImageUrl!: string;
    coverImageName!: string;
    logoUrl!: string;
    logoName!: string;
    testUrl!: string;
    testOptions!: number;

    constructor(data?: IProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.payoff = _data["payoff"];
            this.country = _data["country"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.coverImageUrl = _data["coverImageUrl"];
            this.coverImageName = _data["coverImageName"];
            this.logoUrl = _data["logoUrl"];
            this.logoName = _data["logoName"];
            this.testUrl = _data["testUrl"];
            this.testOptions = _data["testOptions"];
        }
    }

    static fromJS(data: any): ProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["payoff"] = this.payoff;
        data["country"] = this.country;
        data["description"] = this.description;
        data["color"] = this.color;
        data["coverImageUrl"] = this.coverImageUrl;
        data["coverImageName"] = this.coverImageName;
        data["logoUrl"] = this.logoUrl;
        data["logoName"] = this.logoName;
        data["testUrl"] = this.testUrl;
        data["testOptions"] = this.testOptions;
        return data; 
    }
}

export interface IProjectRequest {
    name: string;
    payoff: string;
    country: string;
    description: string;
    color: string;
    coverImageUrl: string;
    coverImageName: string;
    logoUrl: string;
    logoName: string;
    testUrl: string;
    testOptions: number;
}

export class ProjectShortInfoResponse implements IProjectShortInfoResponse {
    id!: number;
    name!: string;
    status!: ProjectStatus;
    userId!: string;
    userEmail!: string;

    constructor(data?: IProjectShortInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.userId = _data["userId"];
            this.userEmail = _data["userEmail"];
        }
    }

    static fromJS(data: any): ProjectShortInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectShortInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["userId"] = this.userId;
        data["userEmail"] = this.userEmail;
        return data; 
    }
}

export interface IProjectShortInfoResponse {
    id: number;
    name: string;
    status: ProjectStatus;
    userId: string;
    userEmail: string;
}

export class Operation implements IOperation {
    value!: any | undefined;
    path!: string | undefined;
    op!: string | undefined;
    from!: string | undefined;

    constructor(data?: IOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        return data; 
    }
}

export interface IOperation {
    value: any | undefined;
    path: string | undefined;
    op: string | undefined;
    from: string | undefined;
}

export class TransferOwnershipRequest implements ITransferOwnershipRequest {
    newOwnerEmail!: string;

    constructor(data?: ITransferOwnershipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newOwnerEmail = _data["newOwnerEmail"];
        }
    }

    static fromJS(data: any): TransferOwnershipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TransferOwnershipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newOwnerEmail"] = this.newOwnerEmail;
        return data; 
    }
}

export interface ITransferOwnershipRequest {
    newOwnerEmail: string;
}

export class ProjectPreviewResponse implements IProjectPreviewResponse {
    name!: string;
    payoff!: string;
    country!: string;
    description!: string;
    color!: string;
    coverImageUrl!: string;
    logoUrl!: string;

    constructor(data?: IProjectPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.payoff = _data["payoff"];
            this.country = _data["country"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.coverImageUrl = _data["coverImageUrl"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): ProjectPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["payoff"] = this.payoff;
        data["country"] = this.country;
        data["description"] = this.description;
        data["color"] = this.color;
        data["coverImageUrl"] = this.coverImageUrl;
        data["logoUrl"] = this.logoUrl;
        return data; 
    }
}

export interface IProjectPreviewResponse {
    name: string;
    payoff: string;
    country: string;
    description: string;
    color: string;
    coverImageUrl: string;
    logoUrl: string;
}

export class ReviewProjectRequest implements IReviewProjectRequest {
    projectIsAccepted!: boolean;
    reviewComments!: string;

    constructor(data?: IReviewProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectIsAccepted = _data["projectIsAccepted"];
            this.reviewComments = _data["reviewComments"];
        }
    }

    static fromJS(data: any): ReviewProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectIsAccepted"] = this.projectIsAccepted;
        data["reviewComments"] = this.reviewComments;
        return data; 
    }
}

export interface IReviewProjectRequest {
    projectIsAccepted: boolean;
    reviewComments: string;
}

export class ProjectSubmitDetailsResponse implements IProjectSubmitDetailsResponse {
    productionUrl!: string;
    companyName!: string;
    address!: string;
    zipCode!: string;
    city!: string;
    contactName!: string;
    contactPhone!: string;
    contactEmail!: string;
    reviewNotes!: string;

    constructor(data?: IProjectSubmitDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionUrl = _data["productionUrl"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.contactEmail = _data["contactEmail"];
            this.reviewNotes = _data["reviewNotes"];
        }
    }

    static fromJS(data: any): ProjectSubmitDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSubmitDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionUrl"] = this.productionUrl;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["contactEmail"] = this.contactEmail;
        data["reviewNotes"] = this.reviewNotes;
        return data; 
    }
}

export interface IProjectSubmitDetailsResponse {
    productionUrl: string;
    companyName: string;
    address: string;
    zipCode: string;
    city: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    reviewNotes: string;
}

export class ProjectSubmitDetailsRequest implements IProjectSubmitDetailsRequest {
    productionUrl!: string;
    companyName!: string;
    address!: string;
    zipCode!: string;
    city!: string;
    contactName!: string;
    contactPhone!: string;
    contactEmail!: string;
    reviewNotes!: string;

    constructor(data?: IProjectSubmitDetailsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productionUrl = _data["productionUrl"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.contactEmail = _data["contactEmail"];
            this.reviewNotes = _data["reviewNotes"];
        }
    }

    static fromJS(data: any): ProjectSubmitDetailsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSubmitDetailsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productionUrl"] = this.productionUrl;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["contactEmail"] = this.contactEmail;
        data["reviewNotes"] = this.reviewNotes;
        return data; 
    }
}

export interface IProjectSubmitDetailsRequest {
    productionUrl: string;
    companyName: string;
    address: string;
    zipCode: string;
    city: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    reviewNotes: string;
}

export class DashboardStatsResponse implements IDashboardStatsResponse {
    totalAccounts!: number;
    newAccountsThisMonth!: number;
    totalProjects!: number;
    newProjectsThisMonth!: number;
    draftProjects!: number;
    pendingProjects!: number;
    acceptedProjects!: number;
    rejectedProjects!: number;

    constructor(data?: IDashboardStatsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalAccounts = _data["totalAccounts"];
            this.newAccountsThisMonth = _data["newAccountsThisMonth"];
            this.totalProjects = _data["totalProjects"];
            this.newProjectsThisMonth = _data["newProjectsThisMonth"];
            this.draftProjects = _data["draftProjects"];
            this.pendingProjects = _data["pendingProjects"];
            this.acceptedProjects = _data["acceptedProjects"];
            this.rejectedProjects = _data["rejectedProjects"];
        }
    }

    static fromJS(data: any): DashboardStatsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStatsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalAccounts"] = this.totalAccounts;
        data["newAccountsThisMonth"] = this.newAccountsThisMonth;
        data["totalProjects"] = this.totalProjects;
        data["newProjectsThisMonth"] = this.newProjectsThisMonth;
        data["draftProjects"] = this.draftProjects;
        data["pendingProjects"] = this.pendingProjects;
        data["acceptedProjects"] = this.acceptedProjects;
        data["rejectedProjects"] = this.rejectedProjects;
        return data; 
    }
}

export interface IDashboardStatsResponse {
    totalAccounts: number;
    newAccountsThisMonth: number;
    totalProjects: number;
    newProjectsThisMonth: number;
    draftProjects: number;
    pendingProjects: number;
    acceptedProjects: number;
    rejectedProjects: number;
}

export class TestUserResponse implements ITestUserResponse {
    id!: number;
    plusUserId!: string;
    name!: string;
    identity!: string;
    email!: string;
    mobileNumber!: string;

    constructor(data?: ITestUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plusUserId = _data["plusUserId"];
            this.name = _data["name"];
            this.identity = _data["identity"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): TestUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TestUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plusUserId"] = this.plusUserId;
        data["name"] = this.name;
        data["identity"] = this.identity;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        return data; 
    }
}

export interface ITestUserResponse {
    id: number;
    plusUserId: string;
    name: string;
    identity: string;
    email: string;
    mobileNumber: string;
}

export class TestUserRequest implements ITestUserRequest {
    plusUserId!: string;
    name!: string;
    identity!: string;
    email!: string;
    mobileNumber!: string;

    constructor(data?: ITestUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plusUserId = _data["plusUserId"];
            this.name = _data["name"];
            this.identity = _data["identity"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): TestUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TestUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plusUserId"] = this.plusUserId;
        data["name"] = this.name;
        data["identity"] = this.identity;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        return data; 
    }
}

export interface ITestUserRequest {
    plusUserId: string;
    name: string;
    identity: string;
    email: string;
    mobileNumber: string;
}

export class UserResponse implements IUserResponse {
    id!: string;
    displayName!: string;
    email!: string;
    emailConfirmed!: boolean;
    showWelcome!: boolean;
    createdAt!: Date;
    roles!: string[];

    constructor(data?: IUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.showWelcome = _data["showWelcome"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["showWelcome"] = this.showWelcome;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }
}

export interface IUserResponse {
    id: string;
    displayName: string;
    email: string;
    emailConfirmed: boolean;
    showWelcome: boolean;
    createdAt: Date;
    roles: string[];
}

export class UserRequest implements IUserRequest {
    displayName!: string;
    password!: string;
    email!: string;
    emailConfirmed!: boolean;
    showWelcome!: boolean;
    roles!: string[];

    constructor(data?: IUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.showWelcome = _data["showWelcome"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["password"] = this.password;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["showWelcome"] = this.showWelcome;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data; 
    }
}

export interface IUserRequest {
    displayName: string;
    password: string;
    email: string;
    emailConfirmed: boolean;
    showWelcome: boolean;
    roles: string[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}